import APIService from "@/services/APIService.js";

const apiContatos = APIService.create({
  baseURL: process.env.VUE_APP_API_URL + "/admin/contatos"
});

export default {
  getAll(limit, page, filters) {
    return apiContatos.get("", {
      params: {
        limit: limit,
        offset: page * limit - limit,
        sort_by: "nome",
        ...filters
      }
    });
  },
};
